import _get from 'lodash/get';
import React from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import EnableForProjectState from '../../../security/EnableForProjectState';
import AnalysesGroupsContainer from '../AnalysesGroupsContainer/AnalysesGroupsContainer';

const ANALYSIS_GROUPS_PATH = 'analyses-groups';

export const analysesGroupsListPath = (projectId) =>
  `/projects/${projectId}/${ANALYSIS_GROUPS_PATH}`;

export const customPath = 'custom';
export const byKfaPath = 'by-kfa';

export const analysesPreferredGroupListPath = (projectId, path) => {
  let preferredPath = '';
  switch (path) {
    case 'custom':
      preferredPath = `${analysesGroupsListPath(projectId)}/${customPath}`;
      break;
    case 'kfa':
      preferredPath = `${analysesGroupsListPath(projectId)}/${byKfaPath}`;
      break;
    case 'none':
      preferredPath = analysesGroupsListPath(projectId);
      break;

    default:
      preferredPath = `${analysesGroupsListPath(projectId)}/${customPath}`;
      break;
  }
  return preferredPath;
};
export const analysesCustomGroupsListPath = (projectId) =>
  `${analysesGroupsListPath(projectId)}/${customPath}`;

export const analysesKFAsGroupsListPath = (projectId) =>
  `${analysesGroupsListPath(projectId)}/${byKfaPath}`;

export const analysesNoneGroupsListPath = (projectId) =>
  `${analysesGroupsListPath(projectId)}`;

const basePath = analysesGroupsListPath(':projectId');

export const routes = [
  {
    path: '',
    component: (props) => <AnalysesGroupsContainer {...props} isNonePage />,
  },
  {
    path: customPath,
    component: (props) => <AnalysesGroupsContainer {...props} isCustomPage />,
  },
  {
    path: byKfaPath,
    component: (props) => <AnalysesGroupsContainer {...props} isKFAsPage />,
  },
];

const AnalysesGroupsContentRouter = () => {
  const { projectId } = useParams();

  return (
    <EnableForProjectState projectId={projectId}>
      {() => (
        <Switch>
          {routes.map((route) => (
            <Route
              key={route.path}
              exact={_get(route, 'exact', true)}
              path={`${basePath}/${route.path}`}
              component={route.component}
            >
              {route.component}
            </Route>
          ))}

          <Route
            path={basePath}
            render={({ match }) => (
              <Redirect to={analysesGroupsListPath(match.params.projectId)} />
            )}
          />
        </Switch>
      )}
    </EnableForProjectState>
  );
};

export default AnalysesGroupsContentRouter;
